import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { getWeekStatus } from "@/orval/gen"
import { DateOnly } from "@/@client/System"

const loader = new DataLoader<DateOnly, number | null>(
  async (keys) => {
    const results = await Promise.all(
      keys.map((startOfWeek) => getWeekStatus({ startOfWeek }))
    )
    return results
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedWeekStatus(startOfWeek: DateOnly | null | undefined) {
  return useQuery({
    queryKey: ["WeekStatus", startOfWeek],
    queryFn: () => loader.load(startOfWeek!),
    enabled: !!startOfWeek,
  })
}
